import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientProductsRoute } from '../../route';

import { clientCardsClickToPayValidateSearchSchema } from './helpers/clientCardsClickToPayValidateSearchSchema';

export const clientCardsClickToPayRoute = createRoute({
	getParentRoute: () => clientProductsRoute,
	path: '/click-to-pay',
	component: lazyRouteComponent(
		() => import('./ClientCardsClickToPayPage'),
		'ClientCardsClickToPayPage',
	),
	validateSearch: clientCardsClickToPayValidateSearchSchema,
});
